import {
	Alert,
	Box,
	Button,
	Drawer,
	Form,
	FormEmailTextFiled,
	FormPhoneNumberTextField,
	FormRef,
	FormTaxCodeTextField,
	FormTextField,
} from '@seeneco-ui/core';
import React, { useEffect, useRef } from 'react';

import { LeadCheckCode } from '@api/leads/model';

type UpdateLeadFormProps = {
	appearance: 'add' | 'edit';
	errorCode: LeadCheckCode | null;
	isFetching: boolean;
	lead: Lead;
	onChange: (formObject: Lead) => void;
	onSearchCompanyCard: () => void;
	onSubmit: (formObject: Lead) => void;
};

const UpdateLeadForm: React.SFC<UpdateLeadFormProps> = props => {
	const { appearance, errorCode, isFetching, lead, onChange, onSearchCompanyCard, onSubmit } = props;
	const formRef = useRef<FormRef>(null);

	useEffect(() => {
		Drawer.default.get().setContent({
			footer: renderDrawerFooter(),
		});
	}, []);

	const handleChange = (formObject: Lead) => onChange(formObject);

	const handleClose = () => Drawer.default.get().close();

	const handleInitSubmit = () => formRef.current && formRef.current.submitForm();

	const handleSeachCompamy = () => onSearchCompanyCard();

	const renderAlert = () => {
		if (errorCode === LeadCheckCode.HAS_SAME_EMAIL) {
			return (
				<Alert appearance='danger' fullWidth>
					Лид с таким e-mail уже существует
				</Alert>
			);
		}

		return null;
	};

	const renderDrawerFooter = () => {
		return (
			<Drawer.default.Footer>
				<Button color='primary' onClick={handleInitSubmit}>
					{appearance === 'add' ? 'Добавить' : 'Изменить'}
				</Button>
				<Button color='default' onClick={handleClose}>
					Отмена
				</Button>
			</Drawer.default.Footer>
		);
	};

	return (
		<Form formObject={lead} isFetching={isFetching} onChange={handleChange} onSubmit={onSubmit} ref={formRef as any}>
			{errorCode && <Box marginBottom='30px'>{renderAlert()}</Box>}
			<Box alignItems='center' display='grid' gridTemplateColumns='auto 100px'>
				<Box marginRight='10px'>
					<FormTaxCodeTextField fullWidth label='ИНН' name='CompanyTaxCode' />
				</Box>
				<Box>
					<Button color='primary' fullWidth onClick={handleSeachCompamy} style={{ minWidth: '100px' }}>
						Найти
					</Button>
				</Box>
			</Box>
			<FormTextField fullWidth label='Компания' name='CompanyName' placeholder='Например, ООО «Ромашка»' required />
			<FormTextField
				fullWidth
				label='Контактное лицо'
				name='ContactName'
				placeholder='Например, Иванов Пётр Алексеевич'
				required
			/>
			<FormPhoneNumberTextField
				appearance='mobile-mask'
				fullWidth
				label='Номер телефона'
				name='ContactPhone'
				required
			/>
			<FormEmailTextFiled fullWidth label='E-mail' name='ContactEmail' placeholder='example@gmail.com' />
			<FormTextField fullWidth label='Комментарий' multiline name='Comment' />
		</Form>
	);
};

UpdateLeadForm.defaultProps = {};
UpdateLeadForm.displayName = 'UpdateLeadForm';

export { UpdateLeadForm, UpdateLeadFormProps };
